import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
import ActivityRegister from "./activity/ActivityRegister";

export class ActivityLog extends Component {
  constructor(props) {
    super(props);
    this.addModalUserRef = React.createRef()
  }

  handleShowAddModalUser = () => {
    this.addModalUserRef.current.showModal()
  };

  render() {
    return (
      <React.Fragment>
        <div>
          <ActivityRegister></ActivityRegister>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
};

export default injectIntl(withRouter(connect(mapStateToProps, {})(ActivityLog)))
